module.exports = __webpack_public_path__ + "img/4.02abea7f.jpg";